export enum ReopenOutcomeDto {
  Reopened = 0,
  Requested = 1
}
